module.exports = __webpack_public_path__ + "assets/media/day32.9cb830ea.mp3";